import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/admin/auth/me");
      setAdmin(r.data);
    } catch {
      setAdmin(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = useCallback(async (email, password) => {
    const r = await api.post("/admin/auth/login", { email, password });
    setAdmin(r.data);
    return r.data;
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/admin/auth/logout"); } catch {}
    setAdmin(null);
  }, []);

  return (
    <AdminAuthContext.Provider value={{ admin, loading, refresh, login, logout, isAuthenticated: !!admin }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error("useAdminAuth must be within AdminAuthProvider");
  return ctx;
}
